// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__128Hc","modalForm":"UpgradeEpcsModal_modalForm__V5lGv","modalFooter":"UpgradeEpcsModal_modalFooter__2iDDP"};